import { render, staticRenderFns } from "./ContentR.vue?vue&type=template&id=dc8aa2c2&scoped=true&"
import script from "./ContentR.vue?vue&type=script&lang=js&"
export * from "./ContentR.vue?vue&type=script&lang=js&"
import style0 from "./ContentR.vue?vue&type=style&index=0&id=dc8aa2c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8aa2c2",
  null
  
)

export default component.exports